import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { BRAND } from "../../data/content";
import { scrollToHash } from "@/lib/scrollToHash";
import fullLogo from "../../assets/blacklion-full-logo.png";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative flex min-h-[calc(100vh-76px)] items-center overflow-hidden pb-28 pt-16 lg:pb-24 lg:pt-14"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={BRAND.heroBg}
          alt="Luxury custom home built by Blacklion Construction, Toronto general contractor"
          className="h-full w-full object-cover"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/55" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-center text-center"
        >
          <img
            src={fullLogo}
            alt="Blacklion Construction Group Inc."
            className="h-48 w-auto object-contain sm:h-60 lg:h-72"
          />

          <div className="mt-8 flex items-center gap-3">
            <span className="h-px w-8 bg-gold" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-white">
              General Contracting · {BRAND.serviceArea}
            </span>
            <span className="h-px w-8 bg-gold" />
          </div>

          <h1 className="font-hero mt-6 text-2xl font-medium tracking-wide text-white sm:text-3xl lg:text-4xl">
            Building with{" "}
            <span className="gold-gradient-text italic">Strength</span>{" "}
            <span className="not-italic">&amp;</span>{" "}
            <span className="gold-gradient-text italic">Precision</span>
          </h1>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row">
            <a
              href="#contact"
              onClick={(e) => scrollToHash(e, "#contact")}
              data-testid="hero-cta-quote"
              className="group inline-flex items-center justify-center gap-2 bg-gold px-8 py-4 text-sm font-bold uppercase tracking-wider text-black transition-all hover:bg-[#c5a059]"
            >
              Get a Free Quote
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href={BRAND.phoneHref}
              data-testid="hero-cta-call"
              className="inline-flex items-center justify-center gap-2 border border-white/25 px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all hover:border-gold hover:text-gold"
            >
              <Phone size={17} />
              {BRAND.phone}
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-2 md:flex">
        <span className="text-[10px] uppercase tracking-[0.3em] text-neutral-500">Scroll</span>
        <span className="h-10 w-px bg-gradient-to-b from-gold to-transparent" />
      </div>
    </section>
  );
};
